import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'copyArray', standalone: true })
export class CopyArrayPipe implements PipeTransform {
  public transform<T>(array?: T[]): T[] {
    return array ? [...array] : [];
  }
}
